import script from "./incomeTax.vue?vue&type=script&setup=true&lang=js"
export * from "./incomeTax.vue?vue&type=script&setup=true&lang=js"

import "./incomeTax.vue?vue&type=style&index=0&id=14ea19ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ea19ca"]])

export default __exports__